module.exports = __webpack_public_path__ + "img/icon_team_01.c64c3aac.png";